/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-array-index-key */
/**
 * View file from URL as Tab;e
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { red500 } from 'styles/colors';
import { useMeasure } from 'react-use';
import { Area, AreaChart, CartesianGrid, XAxis, YAxis } from 'recharts';
import { Tooltip } from 'react-bootstrap';

function interpolate(time, r1, r2) {
  return (
    r1.distance +
    ((time - r1.time) / (r2.time - r1.time)) * (r2.distance - r1.distance)
  );
}

function Graph(props) {
  const { data } = props;
  const [step, setStep] = useState(10);
  const [ref, { width }] = useMeasure();
  let { time, distance } = data[0];
  time += step;
  let lastRow;
  const graphData = [];
  data.forEach(row => {
    while (time <= row.time) {
      const newDistance = interpolate(time, lastRow, row);
      graphData.push({
        time: time / 60,
        speed: (3.6 * (newDistance - distance)) / step,
      });
      distance = newDistance;
      time += step;
    }
    lastRow = row;
  });

  const max = data[data.length - 1].time - data[0].time;

  function handleSubmit(ev) {
    ev.preventDefault();
    setStep(Number(ev.target.elements.time.value));
  }

  const tMinutes = Math.ceil(time / 60);
  const tickStep = [2, 5, 10, 15].find(t => t > tMinutes / 20) || 30;
  const tickCount = Math.ceil(tMinutes / tickStep);
  const ticks = Array.from({ length: tickCount }, (_, i) => i * tickStep);

  return (
    <div ref={ref}>
      <div className="d-flex p-3 align-items-baseline">
        <form
          className="form-inline align-items-baseline"
          onSubmit={handleSubmit}
        >
          <label htmlFor="time">Step (sec)</label>
          <input
            type="number"
            className="form-control mb-2 ml-2 form-control-sm"
            defaultValue={step}
            id="time"
            min={1}
            max={max}
            step={1}
          />
        </form>
      </div>
      <AreaChart
        width={width}
        height={300}
        data={graphData}
        margin={{ bottom: 10, right: 20 }}
      >
        <XAxis
          dataKey="time"
          label={{
            value: 'Minutes',
            position: 'insideBottom',
            offset: -5,
          }}
          type="number"
          domain={[0, tMinutes]}
          ticks={ticks}
        />
        <YAxis
          label={{
            value: 'km/h',
            angle: -90,
            position: 'insideLeft',
            offset: 20,
          }}
        />
        <CartesianGrid strokeDasharray="3 3" />
        <Tooltip />
        <Area
          type="step"
          dataKey="speed"
          stroke={red500}
          fillOpacity={1}
          fill="url(#colorUv)"
          animationDuration={100}
        />
      </AreaChart>
    </div>
  );
}

Graph.propTypes = {
  data: PropTypes.array.isRequired,
};

export default Graph;
